<script lang="ts">
import { computed, defineComponent } from 'vue';

import { CdsIcon } from '@components/components';

import { makeStatusProps, makeTextProps, makeThemeProps, provideTheme, useStatus, useText } from '../../composable';

import type { TCdsIconsName } from '@central-design-system/icons';
import type { PropType } from 'vue';

export const componentName = 'CdsStatus';
export default defineComponent({
  name: componentName,
  components: {
    CdsIcon
  },
  props: {
    icon: {
      /**
       * Статус иконкой
       */
      type: Boolean as PropType<boolean>,
      default: false
    },
    ...makeTextProps(),
    ...makeStatusProps(),
    ...makeThemeProps()
  },
  setup(props, { slots }) {
    const { themeClasses } = provideTheme(props);
    const { statusClasses } = useStatus(props, componentName);
    const { hasText } = useText(props, slots);

    const iconName = computed<TCdsIconsName | undefined>(() => {
      const statusIcons: Record<string, TCdsIconsName> = {
        success: 'check-fill',
        warning: 'alert-fill',
        error: 'error-fill',
        progress: 'clock-fill'
      };

      return statusIcons[props.status] || 'info-fill';
    });

    const classes = computed(() => ({
      'cds-status--icon': props.icon
    }));

    return {
      iconName,
      classes,
      hasText,
      themeClasses,
      statusClasses
    };
  }
});
</script>

<template>
  <span class="cds-status" :class="[themeClasses, statusClasses, classes]">
    <cds-icon v-if="icon" :name="iconName" />

    <span v-if="hasText" class="cds-status__text">
      <template v-if="!!text">{{ text }}</template>
      <!--
        @slot Слот для текста
          @type string
      -->
      <slot v-else />
    </span>
  </span>
</template>

<style lang="scss">
@import './CdsStatus';
</style>
